import { render, staticRenderFns } from "./PaginationInfoWithFilter.vue?vue&type=template&id=05260da5&"
import script from "./PaginationInfoWithFilter.vue?vue&type=script&lang=ts&"
export * from "./PaginationInfoWithFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports